/**
 * Every page address in the app, defined once. The route table (App.tsx), the page permissions
 * (config/permissions.ts), the sidebar and every link read from here — a renamed page cannot leave a
 * broken link or a page nobody may open.
 *
 * Only pages that EXIST are listed. A link to a page that is not built yet (forgot password, privacy,
 * terms, contact — backlog [FE15]) stays a plain string until the page is built, then joins this list.
 */
export const ROUTES = {
  // Public
  HOME: '/',
  RESOURCES: '/resources',
  FORBIDDEN: '/forbidden',
  // Signed in
  DASHBOARD: '/dashboard',
  CHAT: '/chat',
  KNOWLEDGE_BASE: '/knowledge-base',
  ANALYTICS: '/analytics',
  USER_MANAGEMENT: '/user-management',
  KB_ACCESS: '/user-management/kb-access',
  TENANT_CONFIGURATION: '/tenant-configuration',
  EVAL: '/eval',
  HEALTH: '/platform/health',
  /** Old address of the Deployment page, merged into Tenant Configuration ([UX1]) — redirects there. */
  LEGACY_DEPLOYMENT: '/platform/deployment',
} as const;
export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
